import { apiDelete, apiGet } from '../_common';

export default {
  // The supplier codes that stand for the product, each with its supplier's name
  findByProduct(productId) {
    return apiGet('/magenta/fiscal/supplier-product-code', { productId }).then(result => result.response);
  },
  // Codes may hold spaces, dots and slashes, so they travel in the query string
  remove(companyDocumentRoot, supplierCode) {
    const query = new URLSearchParams({ companyDocumentRoot, supplierCode }).toString();
    return apiDelete(`/magenta/fiscal/supplier-product-code?${query}`);
  },
};
